import { Id, User } from 'src/types'

import Api, { make, Response } from '.'

type Data = {
  user: User
}

export function getMe(): Promise<Response<User>> {
  return make<Data, User>({
    axiosCall: Api.get('users/me'),
    transformData: data => data.user
  })
}

export function acceptanceOfTheTerms(user_id: Id): Promise<Response<{}>> {
  return make<Data>({
    axiosCall: Api.post(`users/${user_id}/agree_terms`)
  })
}
